const {Component} = require("react");
const PropTypes = require("prop-types");
const env = require("app/services/env");
const Textarea = require("app/components/fields/Textarea");
const Tooltip = require("app/components/mixins/Tooltip");
const Trans = require('app/components/trans/Trans')

class TextCardSelector extends Component {

	static get propTypes() {
		return {
			option: PropTypes.any,
			text: PropTypes.any,
			maxChars: PropTypes.number,
			onChange: PropTypes.func
		};
	}

	static get defaultProps() {
		return {
			maxChars: 272
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			option: props.option || (this.cards.length > 0 ? this.cards[0].id : null),
			text: props.text || ""
		};
	}

	get cards() {
		return env.get("checkout.textCards", []);
	}

	get options() {
		return this.cards.map(card => {
			return {
				title: card.title,
				value: card.id
			};
		});
	}

	hasText(value) {
		let card = this.cards.filter(card => card.id === parseInt(value)).pop();
		return card ? card.has_text : false;
	}

	get counterText() {
      return translate(':charactersLeft bogstaver tilbage.', {charactersLeft: (this.props.maxChars - this.state.text.length)});
	}

	get inputObservationText() {
		if (this.state.text.length > 0) {
			return;
		}

		if (parseInt(this.state.option) === 9) {
			return translate("Et pænt kort til lejligheden er valgt, men der er ikke indtastet nogen korttekst.");
		}

		if (parseInt(this.state.option) === 7) {
			return translate("Printet korttekst er valgt, men der er ikke indtastet nogen korttekst.");
		}
	}

	get textPlaceholder() {
		return translate("Korttekst..");
	}

	get value() {
		return {
			type: this.state.option,
			text: this.state.text
		};
	}

	reset() {
		const option = this.cards.length > 0 ? this.cards[0].id : null;

		this.selectInput.value = option;

		if (this.textInput) {
			this.textInput.value = "";
		}

		this.setState({
			option: option,
			text: ""
		});
	}

	onChange() {
		if (typeof this.props.onChange === "function") {
			return this.props.onChange(this.value);
		}
	}

	_onSelectorChange = (e) => {
		this.setState({option: e.target.value}, () => {
			this.onChange();
		});
	};

	_onTextInput = () => {
		this.setState({text: this.textInput.value}, () => {
			this.onChange();
		});
	};

	renderOptions() {
		return this.options.map(option => {
			return (
				<option key={option.value} value={option.value}>{option.title}</option>
			);
		});
	}

	renderSelector() {
		return (
			<div className="option-selector">
              <label htmlFor="textCardSelector"><Trans>Vælg korttype og tekst</Trans></label>
              <Tooltip
				   content={translate("Der findes to forskellige slags kort. Et ”pænt kort til lejligheden” er et kort med motiv, der passer til anledningen. Kortet vælges af den lokale florist. En ”printet korttekst” er uden motiv, ligesom et almindelig stykke papir.")} />
				<select id="textCardSelector" ref={el => this.selectInput = el} onChange={this._onSelectorChange}
								defaultValue={this.state.option}>{this.renderOptions()}</select>
			</div>
		);
	}

	renderInputObvervation() {
		let text = this.inputObservationText;

		if (text) {
			return (
				<div className="textObservation">{text}</div>
			);
		}
	}

	renderTextInput() {
		if (!this.hasText(this.state.option)) {
			return;
		}

		return (
			<div className="text-input">
				<Textarea ref={el => this.textInput = el} id="textCardInput" onInput={this._onTextInput}
									defaultValue={this.state.text}
									placeholder={this.textPlaceholder}
									maxLength={this.props.maxChars} limitLines={5}/>
				<div className="char-counter">{this.counterText}</div>
				{this.renderInputObvervation()}
			</div>
		);
	}

	render() {
		return (
			<div className="text-card-widget">
				{this.renderSelector()}
				{this.renderTextInput()}
			</div>
		);
	}

}

module.exports = TextCardSelector;
